module.exports = __webpack_public_path__ + "static/basePath-4777e6e2e5e9517cc7c1b0f16e1d55c9.png";